import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import campaigns from './sidebarItems/campaigns';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenu';

// Responza
import agentis from './sidebarItems/agentis';
import bulkMessage from './sidebarItems/bulkMessage';
import ads from './sidebarItems/ads';
import kanban from './sidebarItems/kanban';



export const getSidebarItems = accountId => ({
  primaryMenu: primaryMenu(accountId),
  secondaryMenu: [
    conversations(accountId),
    contacts(accountId),
    reports(accountId),
    campaigns(accountId),
    settings(accountId),
    notifications(accountId),
    agentis(accountId),//Responza - Agentis
    bulkMessage(accountId),//Responza - Agentis
    ads(accountId),//Responza - Ads
    kanban(accountId),//Responza - Kanban
  ],
});
